import { Card, Text } from "@chakra-ui/react";

interface Props {
  translate?: (name: string) => string;
  active?: boolean;
  payload?: any;
  label?: string;
}
export const PieChartTooltip: React.FC<Props> = ({
  translate,
  active,
  payload,
  label,
}) => {
  if (!payload.length) return null;

  return (
    <Card.Root variant="outline" opacity={0.9} px={4} py={2}>
      <Text fontWeight="bold">{payload[0].value.toFixed(2)} km</Text>
      <Text fontSize="sm">
        {translate ? translate(payload[0].name) : payload[0].name}
      </Text>
    </Card.Root>
  );
};
